import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { initParallaxEffect } from './frontend-parallax';
import { initSlider } from './frontend-slider';
import './styles/frontend.css';

let initialized = false;

function initializeOnce() { 
    if (!initialized) {
        console.log('Initializing parallax effect and slider');
        initParallaxEffect();
        initSlider();
        initialized = true;
    } else {
        console.log('Already initialized, skipping');
    }
}

// Run the initialization when the DOM is ready
if (typeof window !== 'undefined') {
    console.log('Adding event listener for initialization');
    window.addEventListener('DOMContentLoaded', initializeOnce);
}

console.log('Frontend script loaded');

document.addEventListener('DOMContentLoaded', () => {
  if (typeof figportSliderData !== 'undefined' && figportSliderData.customArrowsUrl) {
    initSlider(figportSliderData.customArrowsUrl);
  } else {
    initSlider('');
  }
});